"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.VersionList200ResponseObjectEnum = exports.VersionStatusEnum = exports.VersionObjectEnum = exports.TimeLabelKindEnum = exports.SubscriptionList200ResponseObjectEnum = exports.SubscriptionObjectEnum = exports.ReportList200ResponseObjectEnum = exports.ReportCreatePayloadPeriodAnyOfIntervalEnum = exports.ReportCreatePayloadPeriodIntervalEnum = exports.ReportCreatePayloadGranularityEnum = exports.ReportStatusEnum = exports.ContentList200ResponseObjectEnum = exports.ContentInsightVisualizationAxesInnerFormatEnum = exports.ContentInsightVisualizationAxesInnerTypeEnum = exports.ContentInsightStyleAxesScalarFormatEnum = exports.ContentInsightStyleTypeEnum = exports.ContentInsightGranularityEnum = exports.ContentObjectEnum = exports.CategoryLabelKindEnum = exports.BookmarkList200ResponseObjectEnum = exports.BookmarkObjectEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.BookmarkObjectEnum = {
    Bookmark: 'bookmark'
};
exports.BookmarkList200ResponseObjectEnum = {
    List: 'list'
};
exports.CategoryLabelKindEnum = {
    Category: 'category'
};
exports.ContentObjectEnum = {
    Content: 'content'
};
exports.ContentInsightGranularityEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.ContentInsightStyleTypeEnum = {
    Bar: 'bar',
    Line: 'line',
    Column: 'column',
    Distribution: 'distribution'
};
exports.ContentInsightStyleAxesScalarFormatEnum = {
    Decimal: 'decimal',
    Percentage: 'percentage',
    Currency: 'currency'
};
exports.ContentInsightVisualizationAxesInnerTypeEnum = {
    Time: 'time',
    Category: 'category',
    Scalar: 'scalar',
    Overlay: 'overlay'
};
exports.ContentInsightVisualizationAxesInnerFormatEnum = {
    Percentage: 'percentage',
    Time: 'time',
    String: 'string',
    Currency: 'currency',
    Decimal: 'decimal',
    Integer: 'integer'
};
exports.ContentList200ResponseObjectEnum = {
    List: 'list'
};
exports.ReportStatusEnum = {
    Created: 'created',
    Updating: 'updating',
    Ready: 'ready'
};
exports.ReportCreatePayloadGranularityEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.ReportCreatePayloadPeriodIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.ReportCreatePayloadPeriodAnyOfIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.ReportList200ResponseObjectEnum = {
    List: 'list'
};
exports.SubscriptionObjectEnum = {
    Subscription: 'subscription'
};
exports.SubscriptionList200ResponseObjectEnum = {
    List: 'list'
};
exports.TimeLabelKindEnum = {
    Time: 'time'
};
exports.VersionObjectEnum = {
    Version: 'version'
};
exports.VersionStatusEnum = {
    Draft: 'draft',
    Publishing: 'publishing',
    Active: 'active',
    Archived: 'archived'
};
exports.VersionList200ResponseObjectEnum = {
    List: 'list'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary bookmark create
         * @param {BookmarkCreateRequest} [bookmarkCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkCreate: async (bookmarkCreateRequest, options = {}) => {
            const localVarPath = `/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bookmarkCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary bookmark delete
         * @param {string} bookmarkId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDelete: async (bookmarkId, options = {}) => {
            // verify required parameter 'bookmarkId' is not null or undefined
            (0, common_1.assertParamExists)('bookmarkDelete', 'bookmarkId', bookmarkId);
            const localVarPath = `/bookmarks/{bookmarkId}`
                .replace(`{${"bookmarkId"}}`, encodeURIComponent(String(bookmarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary bookmark list
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkList: async (version, options = {}) => {
            const localVarPath = `/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary bookmark retrieve
         * @param {string} bookmarkId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkRetrieve: async (bookmarkId, options = {}) => {
            // verify required parameter 'bookmarkId' is not null or undefined
            (0, common_1.assertParamExists)('bookmarkRetrieve', 'bookmarkId', bookmarkId);
            const localVarPath = `/bookmarks/{bookmarkId}`
                .replace(`{${"bookmarkId"}}`, encodeURIComponent(String(bookmarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content list
         * @param {string} instance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentList: async (instance, options = {}) => {
            // verify required parameter 'instance' is not null or undefined
            (0, common_1.assertParamExists)('contentList', 'instance', instance);
            const localVarPath = `/contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (instance !== undefined) {
                localVarQueryParameter['instance'] = instance;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary content retrieve
         * @param {string} contentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentRetrieve: async (contentId, options = {}) => {
            // verify required parameter 'contentId' is not null or undefined
            (0, common_1.assertParamExists)('contentRetrieve', 'contentId', contentId);
            const localVarPath = `/contents/{contentId}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary report create
         * @param {ReportCreatePayload} [reportCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCreate: async (reportCreatePayload, options = {}) => {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary report list
         * @param {boolean | null} [template]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportList: async (template, options = {}) => {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary report refresh
         * @param {string} reportId
         * @param {ReportCreatePayload} [reportCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRefresh: async (reportId, reportCreatePayload, options = {}) => {
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportRefresh', 'reportId', reportId);
            const localVarPath = `/reports/{reportId}/refresh`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary report retrieve
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRetrieve: async (reportId, options = {}) => {
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportRetrieve', 'reportId', reportId);
            const localVarPath = `/reports/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary subscription create
         * @param {SubscriptionCreateRequest} [subscriptionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionCreate: async (subscriptionCreateRequest, options = {}) => {
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subscriptionCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary subscription delete
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionDelete: async (subscriptionId, options = {}) => {
            // verify required parameter 'subscriptionId' is not null or undefined
            (0, common_1.assertParamExists)('subscriptionDelete', 'subscriptionId', subscriptionId);
            const localVarPath = `/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary subscription list
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionList: async (version, options = {}) => {
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary subscription retrieve
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionRetrieve: async (subscriptionId, options = {}) => {
            // verify required parameter 'subscriptionId' is not null or undefined
            (0, common_1.assertParamExists)('subscriptionRetrieve', 'subscriptionId', subscriptionId);
            const localVarPath = `/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary version list
         * @param {string} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionList: async (report, options = {}) => {
            // verify required parameter 'report' is not null or undefined
            (0, common_1.assertParamExists)('versionList', 'report', report);
            const localVarPath = `/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (report !== undefined) {
                localVarQueryParameter['report'] = report;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary version retrieve
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionRetrieve: async (versionId, options = {}) => {
            // verify required parameter 'versionId' is not null or undefined
            (0, common_1.assertParamExists)('versionRetrieve', 'versionId', versionId);
            const localVarPath = `/versions/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary bookmark create
         * @param {BookmarkCreateRequest} [bookmarkCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookmarkCreate(bookmarkCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookmarkCreate(bookmarkCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.bookmarkCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary bookmark delete
         * @param {string} bookmarkId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookmarkDelete(bookmarkId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookmarkDelete(bookmarkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.bookmarkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary bookmark list
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookmarkList(version, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookmarkList(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.bookmarkList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary bookmark retrieve
         * @param {string} bookmarkId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookmarkRetrieve(bookmarkId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookmarkRetrieve(bookmarkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.bookmarkRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content list
         * @param {string} instance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentList(instance, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentList(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary content retrieve
         * @param {string} contentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentRetrieve(contentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentRetrieve(contentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.contentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary report create
         * @param {ReportCreatePayload} [reportCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportCreate(reportCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportCreate(reportCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.reportCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary report list
         * @param {boolean | null} [template]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportList(template, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportList(template, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.reportList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary report refresh
         * @param {string} reportId
         * @param {ReportCreatePayload} [reportCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportRefresh(reportId, reportCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportRefresh(reportId, reportCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.reportRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary report retrieve
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportRetrieve(reportId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportRetrieve(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.reportRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary subscription create
         * @param {SubscriptionCreateRequest} [subscriptionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionCreate(subscriptionCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionCreate(subscriptionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.subscriptionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary subscription delete
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionDelete(subscriptionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionDelete(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.subscriptionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary subscription list
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionList(version, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionList(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.subscriptionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary subscription retrieve
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionRetrieve(subscriptionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionRetrieve(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.subscriptionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary version list
         * @param {string} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async versionList(report, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.versionList(report, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.versionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary version retrieve
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async versionRetrieve(versionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.versionRetrieve(versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.versionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary bookmark create
         * @param {DefaultApiBookmarkCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkCreate(requestParameters = {}, options) {
            return localVarFp.bookmarkCreate(requestParameters.bookmarkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary bookmark delete
         * @param {DefaultApiBookmarkDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkDelete(requestParameters, options) {
            return localVarFp.bookmarkDelete(requestParameters.bookmarkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary bookmark list
         * @param {DefaultApiBookmarkListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkList(requestParameters = {}, options) {
            return localVarFp.bookmarkList(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary bookmark retrieve
         * @param {DefaultApiBookmarkRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkRetrieve(requestParameters, options) {
            return localVarFp.bookmarkRetrieve(requestParameters.bookmarkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content list
         * @param {DefaultApiContentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentList(requestParameters, options) {
            return localVarFp.contentList(requestParameters.instance, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary content retrieve
         * @param {DefaultApiContentRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentRetrieve(requestParameters, options) {
            return localVarFp.contentRetrieve(requestParameters.contentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary report create
         * @param {DefaultApiReportCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCreate(requestParameters = {}, options) {
            return localVarFp.reportCreate(requestParameters.reportCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary report list
         * @param {DefaultApiReportListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportList(requestParameters = {}, options) {
            return localVarFp.reportList(requestParameters.template, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary report refresh
         * @param {DefaultApiReportRefreshRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRefresh(requestParameters, options) {
            return localVarFp.reportRefresh(requestParameters.reportId, requestParameters.reportCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary report retrieve
         * @param {DefaultApiReportRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRetrieve(requestParameters, options) {
            return localVarFp.reportRetrieve(requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary subscription create
         * @param {DefaultApiSubscriptionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionCreate(requestParameters = {}, options) {
            return localVarFp.subscriptionCreate(requestParameters.subscriptionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary subscription delete
         * @param {DefaultApiSubscriptionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionDelete(requestParameters, options) {
            return localVarFp.subscriptionDelete(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary subscription list
         * @param {DefaultApiSubscriptionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionList(requestParameters = {}, options) {
            return localVarFp.subscriptionList(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary subscription retrieve
         * @param {DefaultApiSubscriptionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionRetrieve(requestParameters, options) {
            return localVarFp.subscriptionRetrieve(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary version list
         * @param {DefaultApiVersionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionList(requestParameters, options) {
            return localVarFp.versionList(requestParameters.report, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary version retrieve
         * @param {DefaultApiVersionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionRetrieve(requestParameters, options) {
            return localVarFp.versionRetrieve(requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary bookmark create
     * @param {DefaultApiBookmarkCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bookmarkCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bookmarkCreate(requestParameters.bookmarkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary bookmark delete
     * @param {DefaultApiBookmarkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bookmarkDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bookmarkDelete(requestParameters.bookmarkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary bookmark list
     * @param {DefaultApiBookmarkListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bookmarkList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bookmarkList(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary bookmark retrieve
     * @param {DefaultApiBookmarkRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bookmarkRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bookmarkRetrieve(requestParameters.bookmarkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content list
     * @param {DefaultApiContentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentList(requestParameters.instance, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary content retrieve
     * @param {DefaultApiContentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    contentRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).contentRetrieve(requestParameters.contentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary report create
     * @param {DefaultApiReportCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportCreate(requestParameters.reportCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary report list
     * @param {DefaultApiReportListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportList(requestParameters.template, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary report refresh
     * @param {DefaultApiReportRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportRefresh(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportRefresh(requestParameters.reportId, requestParameters.reportCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary report retrieve
     * @param {DefaultApiReportRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportRetrieve(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary subscription create
     * @param {DefaultApiSubscriptionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    subscriptionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionCreate(requestParameters.subscriptionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary subscription delete
     * @param {DefaultApiSubscriptionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    subscriptionDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionDelete(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary subscription list
     * @param {DefaultApiSubscriptionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    subscriptionList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionList(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary subscription retrieve
     * @param {DefaultApiSubscriptionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    subscriptionRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionRetrieve(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary version list
     * @param {DefaultApiVersionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    versionList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).versionList(requestParameters.report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary version retrieve
     * @param {DefaultApiVersionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    versionRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).versionRetrieve(requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map